<template>
  <base-overlay>
    <section>
      <div class="loader">
        <div class="spinner">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="loading">Loading...</div>
      </div>
    </section>
  </base-overlay>
</template>
